export default "__VITE_ASSET__CRxcMNco__"